/* eslint-disable no-misleading-character-class */
import { format } from 'date-fns'
import { FilterOptionsTypesEnum } from 'enum/filterType.enum'
import { IFilterDataArray } from 'interfaces/filterProps'
import { getFilterOperators, getFilterOptionsOperators } from './operators'
import { operatorsList, specialOperators } from 'constants/operators'

export const powerfulTextCompare = (text1: string, text2: string) =>
  text1
    .normalize('NFD')
    .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, '$1')
    .toLowerCase()
    .includes(
      text2
        .normalize('NFD')
        .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, '$1')
        .toLowerCase()
    )

export const arrayGroupBy = (data: any[], attr: string) => {
  const groups = Object.create(null)
  const grouped = [] as any
  data.forEach((item: any, index: number) => {
    if (!groups[item[attr]]) {
      groups[item[attr]] = []
      grouped.push({ group: item[attr] || 0, data: groups[item[attr]], groupCondition: item.condition || 'and' })
    }
    groups[item[attr]].push({ ...item, index })
  })
  if (!grouped.length) return [{ group: 0, data: [] }]
  return grouped
    .map((data: any, index: number) => ({ ...data, group: index, data: data.data.map((row: any) => ({ ...row, group: index })) }))
    .sort((groupA: any, groupB: any) => groupA[attr] - groupB[attr])
}

export const getInputsData = (data: IFilterDataArray, columns: any[], translations: any) => {
  const { input, operator, compareTo, type = 'string', selectedValueData } = data
  const selectedColum = columns.find(({ value }: any) => value === input)
  const inputData = selectedColum?.label || ''
  const operatorData =
    selectedColum && selectedColum.filterOptions
      ? getFilterOptionsOperators(translations.operations, selectedColum.filterOptions, type)?.find(({ value }: any) => value === operator)?.label
      : getFilterOperators(translations.operations, type).find(({ value }) => value === operator)?.label || ''

  let compareToData = ''
  let childrensGroupName

  switch (type) {
    case FilterOptionsTypesEnum.boolean:
      compareToData = ''
      break
    case FilterOptionsTypesEnum.list:
    case FilterOptionsTypesEnum.hybrid:
      if (operatorsList.includes(operator || '') || specialOperators.includes(operator || '')) {
        if (selectedValueData?.label && !operator?.includes('null')) {
          compareToData = selectedValueData.label
        } else {
          compareToData = selectedColum?.list?.find(({ value }: any) => value === compareTo)?.label || ''
        }
      } else {
        compareToData = (!operator?.includes('null') && compareTo) || ''
      }
      break
    case FilterOptionsTypesEnum.tagsList:
      compareToData = selectedColum?.list?.find(({ value }: any) => value === compareTo)?.label || ''
      break
    case FilterOptionsTypesEnum.date:
      compareToData = operator?.includes('null')
        ? ''
        : ['eq', 'lt', 'gt'].includes(operator || '')
          ? format(new Date(compareTo || ''), 'd/M/yyyy')
          : `${compareTo} ${operator?.includes('null') ? '' : translations[Number(compareTo) !== 1 ? 'days' : 'day']}`
      break
    case FilterOptionsTypesEnum.group:
      if (data.childrensGroup) {
        if (selectedValueData?.label) {
          compareToData = selectedValueData.label
        } else {
          compareToData = selectedColum?.list?.find(({ value }: any) => value === compareTo)?.label || ''
        }
        const selectedColumGroup = columns.find(({ type }: any) => type === 'group').list.find(({ value }: any) => value === compareTo)
        const selectedColumChild = selectedColumGroup.childrensGroup.find(({ value }: any) => value === data.childrensGroup.input)
        const result: string = getInputDataChild(data.childrensGroup, [selectedColumGroup], translations)
        childrensGroupName = ` / ${(selectedColumChild?.label || '') + result}`
      }
      break
    default:
      compareToData = (!operator?.includes('null') && compareTo) || ''
      break
  }

  return `${inputData} ${(operatorData || '').toLowerCase()} ${compareToData} ${childrensGroupName || ''}
  `
}

export const getFixedFiltersData = (data: IFilterDataArray, columns: any[], translations: any) => {
  const { input, operator, compareTo, type = 'string', selectedValueData } = data
  const selectedColum = columns.find(({ value }: any) => value === input)
  const inputData = translations.fixedFilters[`${input}`] || ''
  const operatorData =
    selectedColum && selectedColum.filterOptions
      ? getFilterOptionsOperators(translations.operations, selectedColum.filterOptions, type)?.find(({ value }: any) => value === operator)?.label
      : getFilterOperators(translations.operations, type).find(({ value }) => value === operator)?.label || ''
  let compareToData = ''
  switch (type) {
    case FilterOptionsTypesEnum.boolean:
      compareToData = ''
      break
    case FilterOptionsTypesEnum.list:
    case FilterOptionsTypesEnum.hybrid:
      if (operatorsList.includes(operator || '') || specialOperators.includes(operator || '')) {
        if (selectedValueData?.label && !operator?.includes('null')) {
          compareToData = selectedValueData.label
        } else {
          compareToData = selectedColum?.list?.find(({ value }: any) => value === compareTo)?.label || ''
        }
      } else {
        compareToData = (!operator?.includes('null') && compareTo) || ''
      }
      break
    case FilterOptionsTypesEnum.tagsList:
      compareToData = selectedColum?.list?.find(({ value }: any) => value === compareTo)?.label || ''
      break
    case FilterOptionsTypesEnum.date:
      compareToData = operator?.includes('null')
        ? ''
        : ['eq', 'lt', 'gt'].includes(operator || '')
          ? format(new Date(compareTo || ''), 'd/M/yyyy')
          : `${compareTo} ${operator?.includes('null') ? '' : translations[Number(compareTo) !== 1 ? 'days' : 'day']}`
      break
    default:
      compareToData = (!operator?.includes('null') && compareTo) || ''
      break
  }

  return `${inputData} ${(operatorData || '').toLowerCase()} ${compareToData}`
}

const getInputDataChild = (data: IFilterDataArray, columns: any[], translations: any): string => getInputsData(data, columns, translations)
